import React from 'react';

// Catches any render-time crash below it and shows a recoverable screen
// instead of the whole app going blank/white with no way back except a
// manual hard refresh — there was no error boundary anywhere in this app
// (2026-09-30), so ANY uncaught error (e.g. a component trying to render a
// raw object/array — which is exactly what a FastAPI 422 validation error's
// `detail` field is, not a string) took down the entire React tree.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('Unhandled render error caught by ErrorBoundary:', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) {
      return this.props.children;
    }
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: '#f8fafc', padding: '24px', fontFamily: 'system-ui, sans-serif',
      }}>
        <div style={{ maxWidth: 480, textAlign: 'center' }}>
          <h1 style={{ fontSize: 20, fontWeight: 600, color: '#0f172a', marginBottom: 8 }}>
            Something went wrong on this page
          </h1>
          <p style={{ fontSize: 14, color: '#475569', marginBottom: 20 }}>
            Nothing you were working on was lost — the action that caused this either succeeded or
            failed on the server before this crashed. Go back and check before retrying.
          </p>
          <div style={{ display: 'flex', gap: 8, justifyContent: 'center' }}>
            <button
              onClick={() => { this.setState({ error: null }); window.history.back(); }}
              style={{
                padding: '8px 16px', borderRadius: 6, border: '1px solid #cbd5e1',
                background: '#fff', color: '#0f172a', cursor: 'pointer', fontSize: 14,
              }}
            >
              Go back
            </button>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: '8px 16px', borderRadius: 6, border: 'none',
                background: '#0f172a', color: '#fff', cursor: 'pointer', fontSize: 14,
              }}
            >
              Reload page
            </button>
          </div>
        </div>
      </div>
    );
  }
}
